import { gql } from '@apollo/client'

export const Query = gql`
  query ClientType($companyId: ID!, $filters: ClientTypeFilters) {
    clientTypes(companyId: $companyId, filters: $filters, first: 1) {
      nodes {
        id
        name
        color
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
